// extracted by mini-css-extract-plugin
export default {"mainInputContainer":"mainInput_mainInputContainer__KlRXU","placeholder":"mainInput_placeholder__eaRHr","error":"mainInput_error__Sf4pD","input":"mainInput_input__kDPPV"};